import { render, staticRenderFns } from "./AskClaraFooter.vue?vue&type=template&id=0adeecfc&scoped=true&"
import script from "./AskClaraFooter.vue?vue&type=script&lang=js&"
export * from "./AskClaraFooter.vue?vue&type=script&lang=js&"
import style0 from "./AskClaraFooter.vue?vue&type=style&index=0&id=0adeecfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adeecfc",
  null
  
)

export default component.exports